/* RolePicker.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1kk5Tk7GSX%7Bfont-weight%3Avar(--ds-font-weight-semibold%2C600)%7D%0A._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D%0A._0rIjyk1Y8M%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._0wOv4Q7zJH%7Bcursor%3Apointer%7D%0A._0KLXru7Cj1%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D%0A._0jFU0VpJKa%7Bheight%3A3pc%7D%0A._0LQT5E8HPE%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._0hPERGjOvk%3Ahover%7Bborder-color%3Atransparent%7D%0A._1eOmH6KcZT%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D%0A._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._1eOmH6Y9q9%3Ahover%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._3vBAKHnXvL%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._0KLXruDMqu%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D%0A._0hPERGnXvL%3Ahover%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._42Yu6BbFo4%7Bz-index%3A600%7D");



















import React, { useCallback, useEffect, useMemo } from 'react';
import { getDocument } from '@atlaskit/browser-apis';
import { ErrorMessage } from '@atlaskit/form/error-message';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Text } from '@atlaskit/primitives/compiled/text';
import { components } from '@atlaskit/react-select/components';
import type { MenuPortalProps } from '@atlaskit/react-select/menu-portal';
import type { GroupBase } from '@atlaskit/react-select/types';
import Suspense from '@atlaskit/react-ufo/suspense';
import Select from '@atlaskit/select/default';
import type { FormatOptionLabelMeta, ControlProps } from '@atlaskit/select/types';
import { ApplicationEdition } from '@atlassian/invite-people/types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cx } from '@compiled/react';
import { defineMessage, useIntl, FormattedMessage } from 'react-intl';
import { graphql, useFragment, usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import { useAnalytics } from '@townsquare/analytics';
import { ErrorBoundary } from '@townsquare/monitoring/error-boundary';
import { JiraRoleDetail, JiraSpaceOption, RoleSelectOption } from '../../types/SpaceInputTypes';
import { getDefaultRole, getRoleAsOption } from '../../utils/roleUtils';
import { Skeleton } from './Skeleton';
import type { RolePickerWithPermissionQuery } from './__generated__/RolePickerWithPermissionQuery.graphql';
import type { RolePicker_data$key } from './__generated__/RolePicker_data.graphql';
const roleLabelMessage = defineMessage({
  id: 'townsquare.invite-user-modal.role-picker.role-label',
  defaultMessage: 'Select a Jira space role',
  description: 'The label for a dropdown component which allows the user to select the role the invited person will have.'
});
const errorFetchRolesMessage = defineMessage({
  id: 'townsquare.invite-user-modal.role-picker.error-fetch-roles-message',
  defaultMessage: 'Unable to fetch roles. Please try again.',
  description: 'Error message shown when roles could not be fetched.'
});
const noRolesMessage = defineMessage({
  id: 'townsquare.invite-user-modal.role-picker.no-roles-message',
  defaultMessage: 'Unable to get available roles for this space. Please try again.',
  description: 'Error message shown when no roles are available for selection in the role picker.'
});
const controlStyles = {
  root: "_0bjKvDKxmn _3vBAKH9r67 _0wOv4Q7zJH _0KLXru7Cj1 _0jFU0VpJKa _0LQT5E8HPE _0hPERGjOvk _1eOmH6KcZT",
  menuIsOpen: "_0KLXruY9q9 _1eOmH6Y9q9",
  focused: "_3vBAKHnXvL _0KLXruDMqu _0hPERGnXvL",
  menuPortal: "_42Yu6BbFo4"
};
const defaultFormatRoleOptionLabel = (option: RoleSelectOption, {
  context
}: FormatOptionLabelMeta<RoleSelectOption>) => {
  if (context === 'menu') {
    return <Flex direction="column">
				{option.label}
				{option.role.description ? <Text size="small" color="color.text.subtlest">
						{option.role.description}
					</Text> : null}
			</Flex>;
  }
  return option.label;
};
const RolePickerWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    formatMessage
  } = useIntl();
  return <Box>
			<label id="role-picker-input-label" className={ax(["_2sNsIg7NXe _1kk5Tk7GSX _43nrzTPgdg _0rIjyk1Y8M _3iDTPbvLZJ _1UtDYzKGUX"])}>
				{formatMessage(roleLabelMessage)}
			</label>
			{children}
		</Box>;
};
type RolePickerWithPermissionProps = {
  permissionAndRolesQueryRef: PreloadedQuery<RolePickerWithPermissionQuery>;
  setSelectedRole: (role: JiraRoleDetail | undefined) => void;
  selectedRole: JiraRoleDetail | undefined;
  appEdition: ApplicationEdition;
  selectedSpace: JiraSpaceOption;
  isGlobalAdmin: boolean;
};
type RolePickerProps = Omit<RolePickerWithPermissionProps, 'permissionAndRolesQueryRef' | 'isGlobalAdmin'> & {
  permissionAndRolesQueryRef: PreloadedQuery<RolePickerWithPermissionQuery> | null;
  queryRef: RolePicker_data$key;
};
export const RolePicker = ({
  permissionAndRolesQueryRef,
  queryRef,
  ...props
}: RolePickerProps): JSX.Element | null => {
  const globalPermData = useFragment(graphql`
			fragment RolePicker_data on Query @argumentDefinitions(cloudId: { type: "ID!" }) {
				jira {
					isGlobalAdmin: hasGlobalPermission(cloudId: $cloudId, key: ADMINISTER)
						@optIn(to: "JiraHasGlobalPermission")
				}
			}
		`, queryRef);
  const isGlobalAdmin = globalPermData?.jira?.isGlobalAdmin ?? false;
  if (!permissionAndRolesQueryRef) {
    return null;
  }
  return <ErrorBoundary fallback={<RolePickerWrapper>
					<ErrorMessage>
						<FormattedMessage {...errorFetchRolesMessage} />
					</ErrorMessage>
				</RolePickerWrapper>}>
			<Suspense interactionName="role-picker-loading" fallback={<Skeleton labelWidth="30%" testId="teams.invite-user-modal.role-picker.loading-skeleton" />}>
				<RolePickerWithPermission permissionAndRolesQueryRef={permissionAndRolesQueryRef} isGlobalAdmin={isGlobalAdmin} {...props} />
			</Suspense>
		</ErrorBoundary>;
};
const RolePickerWithPermission = ({
  permissionAndRolesQueryRef,
  selectedRole,
  setSelectedRole,
  appEdition,
  selectedSpace,
  isGlobalAdmin
}: RolePickerWithPermissionProps) => {
  const analytics = useAnalytics();
  const data = usePreloadedQuery<RolePickerWithPermissionQuery>(graphql`
			query RolePickerWithPermissionQuery($cloudId: ID!, $projectKey: String!) {
				jira {
					isProjectAdmin: hasProjectPermission(
						cloudId: $cloudId
						permission: ADMINISTER_PROJECTS
						projectKey: $projectKey
					) @optIn(to: "JiraHasProjectPermissionQuery")

					jiraProjectByKey(cloudId: $cloudId, key: $projectKey) {
						roles {
							edges {
								node {
									name
									isDefaultRole
									roleId
									isAdmin
									isRoleConfigurable
									translatedName
									description
								}
							}
						}
					}
				}
			}
		`, permissionAndRolesQueryRef);
  const isProjectAdmin = data?.jira?.isProjectAdmin;
  const roles: JiraRoleDetail[] = useMemo(() => {
    if (!isProjectAdmin && !isGlobalAdmin) {
      return [];
    }
    const edges = data?.jira?.jiraProjectByKey?.roles?.edges ?? [];
    return edges.map(edge => edge?.node).filter((node): node is NonNullable<typeof node> => node != null).map(node => ({
      id: parseInt(node.roleId, 10),
      name: node.name ?? '',
      description: node.description ?? '',
      default: node.isDefaultRole ?? false,
      admin: node.isAdmin ?? false,
      roleConfigurable: node.isRoleConfigurable ?? false,
      translatedName: node.translatedName ?? ''
    }));
  }, [data, isProjectAdmin, isGlobalAdmin]);
  const {
    availableRoles,
    options
  } = useMemo(() => {
    const filtered = appEdition === 'FREE_EDITION' ? roles.filter(role => role.admin) : roles;
    return {
      availableRoles: filtered,
      options: filtered.map(getRoleAsOption)
    };
  }, [roles, appEdition]);
  useEffect(() => {
    void analytics.track('rolePicker', 'loaded', {
      rolesCount: roles.length,
      availableRolesCount: availableRoles.length,
      spaceKey: selectedSpace.key,
      isProjectAdmin,
      isGlobalAdmin,
      noRolesForAdmins: isProjectAdmin || isGlobalAdmin ? availableRoles.length === 0 : undefined
    });
  }, [roles, availableRoles, selectedSpace.key, analytics, isProjectAdmin, isGlobalAdmin]);
  useEffect(() => {
    if (availableRoles.length === 0) {
      if (appEdition === 'FREE_EDITION') {
        void analytics.track('rolePicker', 'freeEditionNoAdminRole', {
          isProjectAdmin,
          isGlobalAdmin,
          appEdition,
          selectedSpaceKey: selectedSpace.key,
          selectedSpaceType: selectedSpace.projectTypeKey,
          selectedSpaceProjectStyle: selectedSpace.projectStyle
        });
      }
      return;
    }
    // Set role based on edition
    const roleToSelect = appEdition === 'FREE_EDITION' ? availableRoles[0] // Free edition: always select first available "admin" role
    : getDefaultRole(availableRoles); // Other editions: use default role logic
    setSelectedRole(roleToSelect);
  }, [availableRoles, appEdition, setSelectedRole, analytics, isProjectAdmin, isGlobalAdmin, selectedSpace]);
  const selectedValue: RoleSelectOption | undefined = useMemo(() => selectedRole ? getRoleAsOption(selectedRole) : undefined, [selectedRole]);
  const onRoleChange = useCallback((option: RoleSelectOption | null) => {
    const role = option?.role;
    setSelectedRole(role);
    void analytics.ui('option', 'selected', {
      selectedRoleId: role?.id,
      spaceKey: selectedSpace.key,
      isProjectAdmin,
      isGlobalAdmin,
      isDefaultRole: role?.default,
      isAdminRole: role?.admin
    }, 'rolePicker');
  }, [setSelectedRole, analytics, selectedSpace, isProjectAdmin, isGlobalAdmin]);
  const renderCustomComponent = useMemo(() => ({
    Control: (props: ControlProps<RoleSelectOption>) => <components.Control {...props} xcss={cx(controlStyles.root, props.isFocused && controlStyles.focused, props.menuIsOpen && controlStyles.menuIsOpen)} />,
    MenuPortal: (props: MenuPortalProps<RoleSelectOption, false, GroupBase<RoleSelectOption>>) => <components.MenuPortal {...props} xcss={controlStyles.menuPortal} />
  }), []);
  if (isGlobalAdmin || isProjectAdmin) {
    if (availableRoles.length > 0) {
      return <RolePickerWrapper>
					<Select components={renderCustomComponent} formatOptionLabel={defaultFormatRoleOptionLabel} isClearable={false} isSearchable={false} isLoading={false} isInvalid={false} isRequired value={selectedValue} options={options} onChange={onRoleChange} fieldId="invite-user-role" id="role-picker-input" labelId="role-picker-input-label" menuPortalTarget={getDocument()?.body} menuPosition="fixed" />
				</RolePickerWrapper>;
    } else {
      return <RolePickerWrapper>
					<ErrorMessage>
						<FormattedMessage {...noRolesMessage} />
					</ErrorMessage>
				</RolePickerWrapper>;
    }
  }
  return null;
};
const labelStyles = null;